<ng-template pTemplate="header">
  <div class="btn-custom">3. Distribuição direta</div>
  <span></span>
</ng-template>

<div class="col-12 md:col-12">
  <div class="flex flex-column gap-2">
    <label for="print-batch-quantity mb-2">Quantidade</label>
    <p-inputNumber inputId="print-batch-quantity" [showButtons]="true" buttonLayout="horizontal" [allowEmpty]="false"
      [(ngModel)]="currentTotal" (ngModelChange)="onChangeTotal()" [min]="0" spinnerMode="horizontal"
      [disabled]="isConfirmed" incrementButtonIcon="fa-solid fa-plus" decrementButtonIcon="fa-solid fa-minus"
      class="w-full"></p-inputNumber>
  </div>
</div>

<div *ngIf="!isConfirmed">

  <distribution-importfile titleDownloadFile="Modelo de planilha para distribuição direta"
    filePathToDownload="/assets/docs/modelo_importacao_distro_direta.xlsx" [isConfirmed]="isConfirmed"
    [directDistribution]="true" [isLoading]="isLoading"
    (parsedData)="handleParsedData($event)"></distribution-importfile>

</div>

<p-toolbar aria-label="Actions" styleClass="mb-6">
  <div class="p-toolbar-group-left">Configuração da distribuição direta</div>
  <div class="p-toolbar-group-right">
    <p-button text label="Remover" icon="pi pi-trash" styleClass="p-button-warning" outlined
      [disabled]="!selectedDistribution || !selectedDistribution.length"
      (onClick)="deleteSelectedProductionItens($event)" />
  </div>
</p-toolbar>

<p-table [value]="Itens" [dataKey]="'id'" styleClass="p-datatable-striped mb-3" [tableStyle]="{ 'min-width': '50rem' }"
  *ngIf="Itens.length > 0" [(selection)]="selectedDistribution" selectionMode="multiply">
  <ng-template pTemplate="header">
    <tr>
      <th class="cursor-default" style="width: 4rem">
        <p-tableHeaderCheckbox [disabled]="isConfirmed" />
      </th>
      <th class="cursor-default" style="width: 300px">Prefixo</th>
      <th class="cursor-default" style="width: 100px">Quantidade</th>
      <th class="cursor-default" style="width: 160px">Data de entrega</th>
      <th class="cursor-default" style="width: 40px">Ação</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-distribution let-i="rowIndex">
    <tr>
      <td>
        <p-tableCheckbox [value]="distribution" [disabled]="isConfirmed" />
      </td>
      <td class="cursor-default">
        {{ distribution.detail.label }}
      </td>
      <td>
        <p-inputNumber inputId="print-batch-quantity" [(ngModel)]="distribution.quantity" [showButtons]="true"
          (ngModelChange)="onChangeData()" buttonLayout="horizontal" [disabled]="isConfirmed" [allowEmpty]="false"
          [min]="0" spinnerMode="horizontal" [disabled]="isLoading || isConfirmed"
          incrementButtonIcon="fa-solid fa-plus" decrementButtonIcon="fa-solid fa-minus" class="w-full"></p-inputNumber>
      </td>
      <td>
        <p-calendar [(ngModel)]="distribution.detail.deliveryAt" [showButtonBar]="true" [showIcon]="true"
          (ngModelChange)="onChangeData()" [minDate]="minDate" [disabled]="isConfirmed" [disabled]="isConfirmed"
          [readonlyInput]="false" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
      </td>
      <td>
        <p-button icon="fa-solid fa-times" styleClass="p-button p-button-danger p-button-text" pTooltip="Remover"
          [disabled]="isConfirmed" tooltipPosition="left" [disabled]="isConfirmed"
          (onClick)="removeDeliveryWayDirect($event, distribution, i)"
          *ngIf="deliveryWayCanBeRemoved(distribution)"></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="p-fluid grid formgrid" *ngIf="!isConfirmed">
  <div class="field col-12 md:col-12">
    <label for="print-batch-restricted-prefix2" [class.required]="deliveryWayDirect.length === 0">Prefixo</label>
    <p-autoComplete id="print-batch-restricted-prefix2" [(ngModel)]="printBatchRestrictedPrefix"
      [suggestions]="printBatchRestrictedPrefixOptions" (completeMethod)="filterDeliveryWayDirect($event)" field="label"
      (onSelect)="addDeliveryWayDirect($event)"></p-autoComplete>

    <small class="cursor-default">Digite o prefixo da dependência de destino ou algo similar. Pode usar o teclado, é
      mais
      fácil. Para escolher pressione a tecla Enter.</small>
  </div>
</div>